import React from 'react';
import SvgIconButton from '../../../common/SvgIconButton';
import usePage from '../../../../hooks/use-page';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { NavigationDirection } from '../../../../types';
import { NavigationButtonProps } from '../../../activities/ArrowNavigationButton';
import { hasNextPage, hasPreviousPage, isCoverPage } from '../../../../util/paging-util';

type Props = {
  handleContinue?: any;
  hasCover?: boolean;
  ArrowNavigationButton?: React.FC<NavigationButtonProps>;
  disableNextButton?: boolean;
  disablePreviousButton?: boolean;
};

const NavigationControl: React.FC<Props> = ({
  hasCover = false,
  handleContinue,
  ArrowNavigationButton = SvgIconButton,
  disableNextButton = false,
  disablePreviousButton = false,
}) => {
  const classes = useStyles();
  const [{ currentPage, totalPages, noOfPages, firstPage }, { handlePageTurn }] = usePage();

  const handleTurnPage = (direction: NavigationDirection) => {
    if (handleContinue) {
      handleContinue(direction);
    } else {
      handlePageTurn(direction, isCoverPage(hasCover, currentPage, firstPage));
    }
  };

  return (
    <>
      <div className={`${classes.btnStyle} navigationIconLeft`}>
        <ArrowNavigationButton
          disabled={!hasPreviousPage(currentPage, firstPage) || disableNextButton}
          iconProps={{ icon: faArrowLeft, size: '3x' }}
          ariaLabel={tA11y('buttons.previousPage')}
          onClick={() => handleTurnPage(NavigationDirection.Previous)}
          direction={NavigationDirection.Previous}
        />
      </div>
      <div className={`${classes.btnStyle} navigationIconRight`}>
        <ArrowNavigationButton
          disabled={
            !hasNextPage(currentPage, noOfPages, totalPages, firstPage) || disablePreviousButton
          }
          iconProps={{ icon: faArrowRight, size: '3x' }}
          ariaLabel={tA11y('buttons.nextPage')}
          onClick={() => handleTurnPage(NavigationDirection.Next)}
          direction={NavigationDirection.Next}
        />
      </div>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  btnStyle: {
    position: 'absolute',
    top: '50%',
    border: 'none',
    background: 'transparent',
    zIndex: theme.zIndex.appBar,
    '&.navigationIconLeft': {
      left: 0,
      transform: 'translate(50%, -50%)',
    },
    '&.navigationIconRight': {
      right: 0,
      transform: 'translate(-50%, -50%)',
    },
  },
}));

export default NavigationControl;
